import { Injectable, signal } from '@angular/core';
import { Identity } from '../model';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthRefreshState {
    /** Signal to track whether refresh is happening */
    readonly refreshing = signal(false);

    /** Queued requests wait for this */
    readonly refresh$ = new BehaviorSubject<Identity | null>(null);
}
